import handleSagaError from '../../redux/handleSagaError';
import { apiClient } from '../../utils';

const acceptInvoice = async (orderId) =>
  apiClient
    .post('/merchant/order/accept', { data: { orderId } })
    .then(({ result }) => result)
    .catch(handleSagaError);

export { acceptInvoice };
